export default __webpack_public_path__ + "static/media/ISEO CLASS-4 EXAM PATTERN 2026-27.3df66fd0.pdf";